import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DebugSiteApiService, WordPressInstance } from '../../core/debug-site';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-debug-site-card',
  templateUrl: './debug-site-card.component.html',
  styleUrls: ['./debug-site-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DebugSiteComponent implements OnInit {
  @Input() instance: WordPressInstance;

  cardTitleKey: string;
  cardSubTitleKey: string;
  toggleLabelKey: string;
  disableButton$: Observable<boolean>;
  toggleEnabled$: Observable<boolean>;
  toggleStatusKey$: Observable<string>;

  constructor(private debugService: DebugSiteApiService) {
    this.toggleEnabled$ = this.debugService.getDebugFlags$().pipe(map((debugFlags) => debugFlags.debugEnabled()));
    this.disableButton$ = this.debugService.getLoading$();
    this.toggleStatusKey$ = this.toggleEnabled$.pipe(
      map((toggleEnabled) => (toggleEnabled ? 'DEBUG_CARD.TOGGLE_ON' : 'DEBUG_CARD.TOGGLE_OFF')),
    );
  }

  ngOnInit(): void {
    this.debugService.loadDebugFlags(this.instance);
    this.toggleLabelKey = 'DEBUG_CARD.TOGGLE_LABEL';
    if (this.instance === WordPressInstance.staging) {
      this.cardTitleKey = 'DEBUG_CARD.STAGING.TITLE';
      this.cardSubTitleKey = 'DEBUG_CARD.STAGING.SUBTITLE';
    } else {
      this.cardTitleKey = 'DEBUG_CARD.LIVE.TITLE';
      this.cardSubTitleKey = 'DEBUG_CARD.LIVE.SUBTITLE';
    }
  }

  toggleVal(checked: boolean): void {
    this.debugService.setDebug(this.instance, checked);
  }
}
